import {getDamageDiceFaceOutcomes} from "./getDamageDiceFaceOutcomes";

// Матожидание грани кости урона при подкрутках броска (см.
// getDamageDiceFaceOutcomes). Честная кость: -7/6 (около -1.17); пол 2: -0.8;
// пол 3: -0.5; пол 3 и +1: -0.25; пол 6 («божество»): 0. Со штрафом форы
// новичкам (facePenalty 1) честная кость дает -2
export const calcExpectedDamageDiceFace = (minRoll = 1, rollBonus = 0, facePenalty = 0) => {
  const faces = getDamageDiceFaceOutcomes(minRoll, rollBonus, facePenalty);
  return faces.reduce((sum, face) => sum + face, 0) / faces.length;
};
